module.exports = __webpack_public_path__ + "img/logo.0a2649c0.gif";